<template>
  <el-scrollbar :ref="scrollbarRef">
    <div class="full" style="display: flex; justifyContent: space-between;">
      <div :style="isSplitted ? { width: 'calc(50% - 10px)' } : { width: '100%' }">
        <w-realtime-log-search ref="logSearchOrigin" :search-keywords="searchHistory" :is-first="true" :active="active" :field-options="fieldOptions"
          @split-table="splitTable" @set-search-history="setSearchHistory" @delete-all-history="deleteAllHistory" @delete-by-index="deleteByIndex" @change-search-tags="onChangeSearchTags" />
      </div>
      <div v-if="isSplitted" style="width: calc(50% - 10px);">
        <w-realtime-log-search ref="logSearchSecond" :search-keywords="searchHistory" :is-first="false" :active="active" :field-options="fieldOptions"
          @set-search-history="setSearchHistory" @delete-all-history="deleteAllHistory" @delete-by-index="deleteByIndex" @change-search-tags="onChangeSearchTags" />
      </div>
    </div>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import { isEmpty, cloneDeep, findIndex } from 'lodash';

import ScrollbarMixin from '@/mixins/scrollbar';
import LogAPI from '@/api/log/integrated-log';
import msgUtil from '@/utils/message';

import WRealtimeLogSearch from './components/RealtimeLogSearch';

export default {
  name: 'WSearch',
  mixins: [ScrollbarMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WRealtimeLogSearch,
  },
  data() {
    return {
      isSplitted: false,
      keywords: [],
      searchHistory: [],
      fieldOptions: [],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    span() {
      return this.isSplitted ? 12 : 24;
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(value) {
        this.isSplitted = false;
        if (value) {
          this.loadDefaultShowFields();
        }
      },
    },
    keywords: {
      immediate: true,
      deep: true,
      handler(item) {
        const keywords = cloneDeep(item);
        if (!isEmpty(item)) {
          const keywordsLength = keywords.length;
          item.forEach((keyword, index) => {
            keywords[keywordsLength - index - 1] = keyword;
          });
          this.searchHistory = keywords;
        } else {
          this.searchHistory = null;
        }
      },
    },
    selectedNode: {
      immediate: true,
      handler() {
        this.isSplitted = false;
        if (this.active) {
          this.loadDefaultShowFields();
        }
      },
    },
  },
  mounted() {
    this.setScrollData();
    this.$nextTick(() => {
      this.isSplitted = false;
    });
  },
  methods: {
    /**
     * 쿠키에 저장된 검색어 이력을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    initSearchHistory() {
      if (!isEmpty(Cookies.getJSON('searchHistory'))) {
        this.keywords = Cookies.getJSON('searchHistory').keywords;
      }
    },
    /**
     * 좌측에서 선택한 트리 노드에 알맞게 그리드에 보여줄 필드 정보를 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadDefaultShowFields() {
      if (this.selectedNode.type === 'dataindex') {
        const params = {
          params: {
            dataindexId: this.selectedNode.dataindexId,
          },
        };
        LogAPI.getLogFieldsByIndex(params).then((response) => {
          if (response.data.success) {
            const fieldOptions = response.data.data;
            this.fieldOptions = fieldOptions;
            this.initSearchHistory();
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드', false));
          throw new Error(e);
        });
      } else {
        LogAPI.getLogShowFields().then((response) => {
          if (response.data.success) {
            this.fieldOptions = response.data.data;
            this.initSearchHistory();
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드', false));
          throw new Error(e);
        });
      }
    },
    splitTable() {
      this.isSplitted = !this.isSplitted;
    },
    /**
     * 검색어를 쿠키에 저장한다.(최대 maxKeywordLength개)
     * @author Minyeong
     * @param  {[type]} value [description]
     */
    setSearchHistory(value) {
      const maxKeywordLength = 10;
      const searchHistory = Cookies.getJSON('searchHistory');
      const searchKeyword = value.value;
      if (isEmpty(searchHistory) || isEmpty(searchHistory.keywords)) {
        const history = {
          keywords: [searchKeyword],
        };
        Cookies.set('searchHistory', history);
      } else {
        const keywords = searchHistory.keywords;
        if (keywords.length === maxKeywordLength) {
          keywords.splice(0, 1);
        }
        // 이미 검색 이력에 존재하는 키워드인지 확인 >> 존재하는 키워드라면 기존 것을 삭제 후 새로 push
        const index = findIndex(keywords, (item) => searchKeyword === item);
        if (index !== -1) {
          keywords.splice(index, 1);
        }
        keywords.push(searchKeyword);
        const history = {
          keywords,
        };

        Cookies.set('searchHistory', history);
      }
      this.keywords = Cookies.getJSON('searchHistory').keywords;
    },
    /**
     * 모든 검색 이력을 삭제한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    deleteAllHistory() {
      Cookies.set('searchHistory', null);
      this.keywords = null;
    },
    /**
     * 단일 검색 이력을 삭제한다.
     * @author Minyeong
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    deleteByIndex(index) {
      const keywords = Cookies.getJSON('searchHistory').keywords;
      const keywordsLength = keywords.length;
      keywords.splice(keywordsLength - index - 1, 1);
      Cookies.set('searchHistory', { keywords });
      this.keywords = keywords;
    },
    onChangeSearchTags(value) {
      this.$emit('change-search-tags', value);
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/RealtimeSearch/index.vue